




































































import { Component, Vue, Model, Emit } from "vue-property-decorator";
import { Auth } from "../../unite/auth";
import { isValidUsername } from "../../unite/validate";
import { Form as ElForm, Input } from "element-ui";

@Component({ components: {} })
export default class Login extends Vue {
  auth = new Auth();
  private validateUsername = (rule: any, value: string, callback: Function) => {
    if (!isValidUsername(value)) {
      callback(new Error("Please enter the correct user name"));
    } else {
      callback();
    }
  };
  private validatePassword = (rule: any, value: string, callback: Function) => {
    if (value.length < 6) {
      callback(new Error("The password can not be less than 6 digits"));
    } else {
      callback();
    }
  };
  width: string = "70px";
  private loginForm = {
    account: "",
    password: "",
    code: ""
  };
  private loginRules = {
    account: [
      {
        required: true,
        message: "请输入用户名",
        trigger: "blur"
      }
    ],
    password: [
      {
        required: true,
        message: "请输入密码",
        trigger: "blur"
      }
    ]
  };
  mounted() {
    if (this.loginForm.account === "") {
      (this.$refs.password as Input).focus();
    } else if (this.loginForm.password === "") {
      (this.$refs.password as Input).focus();
    }
    if (window.location.href.indexOf("localhost") > -1) {
      this.loginForm.account = "admin";
      this.loginForm.password = "CSWFn99/NxbLD+pmMhB04BjR/ha0K+bxRW2/i317Vho";
    }
  }
  goLogin(formName: any) {
    (this.$refs[formName] as any).validate((valid: boolean) => {
      if (valid) {
        this.auth.goLogin(this.loginForm, this.$router);
      } else {
      }
    });
  }
  // 刷新列表
  refesh(bool: boolean) {
    // if (bool) {

    // }
    this.auth.isOtp = false;
  }
}
